import { render } from "./Footer.vue?vue&type=template&id=560541fc&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=560541fc&scoped=true&lang=css"

import exportComponent from "/Users/jx/Projects/saas.foghashing.io-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560541fc"]])

export default __exports__